import { isArray } from "lodash";

export const convertToSentenceCase = (word: string): string => {
    if (!word) return "";

    return `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`;
};

export const sanitizeResponse = (word: string): string => {
    return word.toLocaleLowerCase().replace(/[^\w\sñáóíéú]/gi, "");
};

export const getDropdownLabel = (secondaryLanguages?: string[] | string): string => {
    if (!(secondaryLanguages && secondaryLanguages?.length > 0)) {
        return "Secondary language";
    }

    if (isArray(secondaryLanguages)) {
        return secondaryLanguages
            .slice(0, 3)
            ?.map((v, i) => v.slice(0, 3) + (secondaryLanguages?.length > 3 && i === 2 ? "..." : ""))
            .join(", ");
    }

    return secondaryLanguages;
};

export const isNumeric = (input: string): boolean => {
    return !Number.isNaN(parseFloat(input.trim()));
};

export const removeEmptyStringsOrHttpFromArray = (input: string[]): string[] => {
    return input.filter((i) => i.trim() !== "" && !i.trim().includes("http") && !isNumeric(i.trim()));
};
